import axios from "axios";
import $store from "../store";
import "../env/.env.js"
import md5 from "md5-js/md5";

//请求防抖需要收集请求中的集合，并控制过滤
let request_list = [];
let white_list = []
const instance = axios.create({
	baseURL: process.uniEnv.WS_API,
	timeout: 30000
});

const defaultOpt = {
	login: true
};

function baseRequest(options) {

	return instance(options).then(res => {
		const data = res.data || {};

	
		if (res.status !== 200) {
			return Promise.reject({
				msg: "请求失败",
				res,
				data
			});
		}


		if (data.code === 0) {  // TP6接口正常返回响应
			return Promise.resolve(data, res);
		} else if (res.config.headers?.['api-usage'] === 'oss') {  // 阿里云OSS前端直传类型
			return Promise.resolve(data, res);
		} else {
			return Promise.reject({
				msg: res.data.msg,
				res,
				data
			});
		}
	});
}

/**
 * http 请求基础类
 * 参考文档 https://www.kancloud.cn/yunye/axios/234845
 *
 */
const request = ["post", "put", "patch"].reduce((request, method) => {
	/**
	 *
	 * @param url string 接口地址
	 * @param data object get参数
	 * @param options object axios 配置项
	 * @returns {AxiosPromise}
	 */
	request[method] = (url, data = {}, options = {}) => {
		return baseRequest(
			Object.assign({
				url,
				data,
				method
			}, defaultOpt, options)
		);
	};
	return request;
}, {});

["get", "delete", "head"].forEach(method => {
	/**
	 *
	 * @param url string 接口地址
	 * @param params object get参数
	 * @param options object axios 配置项
	 * @returns {AxiosPromise}
	 */
	request[method] = (url, params = {}, options = {}) => {
		return baseRequest(
			Object.assign({
				url,
				params,
				method
			}, defaultOpt, options)
		);
	};
});

instance.interceptors.request.use(async (config) => {
	const token = $store.state.token;
	config.headers['Authorization'] = "Bearer " + token;
	let flag = await stopRepeatRequest(request_list, config, `${config.url} 请求重复`)
	if (flag) {
		return Promise.reject({
			msg: `休息一下，操作太快啦~`,
		})
	}
	return config
}, (error) => {
	console.log('interceptor:', error)
})
instance.interceptors.response.use((response) => {
	allowRequest(request_list, response.config)
	return response
})

//请求中的URL集合
function stopRepeatRequest(reqList, config, errorMessage) {
	let unique_key = md5(config.url)
	// URL过滤白名单
	if(white_list.filter(item => item.includes(unique_key)).length === 0) {
		return false
	}
	if(config.method === "get") {
		// console.log('push', config.url, JSON.stringify(config.params))
		unique_key = md5(config.url + JSON.stringify(config.params))
	}
	if(config.method === "post") {
		// console.log('push',config.url, JSON.stringify(config.data))
		unique_key = md5(config.url + JSON.stringify(config.data))
	}

	if (reqList.length) {
		let arr= reqList.filter(item => item === unique_key )
		if(arr.length) {
			console.log(errorMessage)
			return true
		}
	}
	reqList.push(unique_key)
	// console.log('stopRepeatRequest', config, reqList)
	return false;
}
//单个请求结束后的URL
function allowRequest (reqList, config) {
	let unique_key = md5(config.url)
	if(config.method === "get") {
		// console.log('pop',config.url, JSON.stringify(config.params))
		unique_key = md5(config.url + JSON.stringify(config.params))
	}
	if(config.method === "post") {
		// console.log('pop',config.url, config.data)
		unique_key = md5(config.url + JSON.stringify(config.data))
	}
	if (reqList.length) {
		request_list = reqList.filter(item => !(item === unique_key))
	}
	// console.log('allowRequest', config, reqList)
}

export default request;
